import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import React from 'react'

const useProductsSharedPropertyLabelStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: pxToRem(20),
    },
    grayText: {
        color: theme.palette.grey[500],
        fontSize: pxToRem(14),
        textAlign: 'center',
    },
}))

export const ProductsSharedPropertyLabel = React.memo(
    ({ content }: { content: string }) => {
        const classes = useProductsSharedPropertyLabelStyles()
        // isOMorSMM ? Please select the Family Level to load Part 1 and Part 3 content : load PT

        return (
            <div className={classes.container}>
                <Typography
                    data-testid="enableSharedProperties"
                    component="span"
                    className={classes.grayText}
                >
                    {content ||
                        'Enable Shared Properties to view related content between ProductTypes.'}
                </Typography>
            </div>
        )
    }
)
